import { render, staticRenderFns } from "./ProductListHorizon.vue?vue&type=template&id=78286934&scoped=true&"
import script from "./ProductListHorizon.vue?vue&type=script&lang=js&"
export * from "./ProductListHorizon.vue?vue&type=script&lang=js&"
import style0 from "./ProductListHorizon.vue?vue&type=style&index=0&id=78286934&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78286934",
  null
  
)

export default component.exports